import { normalize } from "normalizr";
import * as uuid from "react-native-uuid";
import * as schema from "./schema";
import Client from "../Client";
import {
  RUNSHEET_FETCHED,
  ADD_JOB,
  UPDATE_RUNSHEET,
  VEHICLES_FETCHED,
  GENERATE_RUNSHEET,
  USERS_FETCHED,
  RUNSHEET_CANCELLED,
  RUNSHEET_UPDATED,
  DUPLICATE_RUNSHEET,
  LOCATIONS_FETCHED,
  UPLOAD_RUNSHEET
} from "../types";

export const generateRunsheet = () => dispatch => {
  const externalId = uuid.v4();
  dispatch({ type: GENERATE_RUNSHEET, payload: externalId });
  return externalId;
};

export const getRunsheets = options => dispatch =>
  Client.getRunsheets(options).then(response => {
    dispatch({
      type: "GET_RUNSHEETS",
      payload: {
        runsheets: response.runsheets,
        total: parseInt(response.meta["x-total-count"], 10)
      }
    });
    return response;
  });

export const getCalendarRunsheets = options => dispatch =>
  Client.getRunsheetsInDateRange(options).then(response => {
    dispatch({
      type: "GET_CALENDAR_RUNSHEETS",
      payload: {
        runsheets: response
      }
    });
    return response;
  });

export const updateVehicle = (runsheetId, vehicle) => dispatch => {
  dispatch({
    type: "UPDATE_VEHICLE",
    payload: { runsheetId, vehicle }
  });
};

export const removeVehicle = runsheetId => dispatch => {
  dispatch({
    type: "REMOVE_VEHICLE",
    payload: { runsheetId }
  });
};

export const getRunsheet = runsheetId => dispatch =>
  Client.getRunsheet(runsheetId).then(runsheet => {
    dispatch({
      type: RUNSHEET_FETCHED,
      payload: normalize(runsheet, schema.runsheet)
    });
    return runsheet;
  });

export const getExternalEntities = () => dispatch =>
  Client.getExternalEntities().then(response => {
    dispatch({
      type: VEHICLES_FETCHED,
      payload: normalize(response.vehicles, schema.vehicleList)
    });
    dispatch({
      type: USERS_FETCHED,
      payload: normalize(response.users, schema.userList)
    });
    dispatch({
      type: LOCATIONS_FETCHED,
      payload: normalize(response.locations, schema.locationList)
    });
    return response;
  });

export const addRunsheetJob = (runsheetExternalId, sequence) => dispatch => {
  const jobExternalId = uuid.v4();

  dispatch({
    type: ADD_JOB,
    payload: {
      runsheetExternalId,
      jobExternalId,
      sequence
    }
  });

  return jobExternalId;
};

export const updateRunsheet = (runsheetId, attributes) => dispatch => {
  dispatch({
    type: UPDATE_RUNSHEET,
    payload: { runsheetId, attributes }
  });
};

export const createRunsheet = attributes => dispatch =>
  Client.createRunsheet(attributes).then(runsheet => {
    dispatch({ type: RUNSHEET_UPDATED, payload: runsheet });
    return runsheet;
  });

export const syncUpdateRunsheet = (runsheetId, attributes) => dispatch =>
  Client.updateRunsheet(runsheetId, attributes).then(runsheet => {
    dispatch({ type: RUNSHEET_UPDATED, payload: runsheet });
    return runsheet;
  });

export const duplicateRunsheet = runsheetExternalId => dispatch =>
  Client.duplicateRunsheet(runsheetExternalId).then(runsheet => {
    dispatch({
      type: DUPLICATE_RUNSHEET,
      payload: normalize(runsheet, schema.runsheet)
    });
    return runsheet;
  });

export const cancelRunsheet = runsheetId => dispatch =>
  Client.cancelRunsheet(runsheetId).then(() => {
    dispatch({ type: RUNSHEET_CANCELLED, payload: runsheetId });
  });

export const allocateRunsheet = (runsheetId, attributes) => dispatch =>
  Client.updateRunsheet(runsheetId, attributes).then(runsheet => {
    dispatch({
      type: UPDATE_RUNSHEET,
      payload: {
        runsheetId: runsheet.externalId,
        vehicle: attributes.vehicle.id
      }
    });
  });

export const uploadRunsheet = attributes => dispatch =>
  Client.uploadRunsheet(attributes).then(response => {
    dispatch({ type: UPLOAD_RUNSHEET, payload: response });
    return response;
  });



// WEBPACK FOOTER //
// ./src/actions/runsheets.js